module.exports = __webpack_public_path__ + "img/img_download_ios@2x.3c1ea461.png";